import { z } from 'zod';

import type {
  GetHoldingUnitTechnicalAuditRequest,
  GetHoldingUnitTechnicalAuditResponse,
} from './holding-unit-technical-audit.dto.js';
import { HoldingUnitStreamEventSchema } from './holding-units-events.schema.js';

export const GetHoldingUnitTechnicalAuditRequestSchema: z.ZodType<GetHoldingUnitTechnicalAuditRequest> =
  z
    .object({
      companyId: z.uuid(),
      unitId: z.uuid(),
      from: z.iso.datetime().optional(),
      to: z.iso.datetime().optional(),
      limit: z.number().int().positive().optional(),
    })
    .strict();

export const GetHoldingUnitTechnicalAuditResponseSchema: z.ZodType<GetHoldingUnitTechnicalAuditResponse> =
  z
    .object({
      items: z.array(HoldingUnitStreamEventSchema),
    })
    .strict();
